module.exports = __webpack_public_path__ + "static/media/29.fd3ac6ed.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/files/29.jpeg
// module id = 89
// module chunks = 0